import DashboardView from "../DashboardView.vue";
import DashboardPage from "../Pages/DashboardPage.vue";

const routes = [
  {
    path: '/',
    component: DashboardView,
    children: [
      {
        path: '',
        roles: ['dashboard'],
        name: 'dashboard',
        component: DashboardPage,
      },
    ]
  }
]

export default routes
